import { TermAndConditionModel } from 'api-hooks/term-and-condition/model';
import Config from 'common/config';
import Stack from 'components/commons/stack';
import Text from 'components/commons/text';
import staticFilePaths from 'constant/static-file';
import { styles } from 'modules/home/style';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';

import { ContainerContent } from './styles';

interface Props {
  data: TermAndConditionModel;
}
export default function TermAndCondition(props: Props) {
  const { data } = props;
  let markup = '';
  let draftToHtml: any = null;
  const { t } = useTranslation();
  const { locale } = useRouter();

  if (typeof window === 'object') {
    draftToHtml = require('draftjs-to-html');
  }

  if (data.content && draftToHtml) {
    markup = draftToHtml(JSON.parse(data.content));
  }
  return (
    <>
      <NextSeo
        title={t('common:title_term_and_condition')}
        description={t('common:description_term_and_condition')}
        canonical={Config.apiEndpoint + '/term-and-condition'}
        openGraph={{
          type: 'website',
          locale,
          url: Config.apiEndpoint + '/term-and-condition',
          title: t('common:title_term_and_condition'),
          description: t('common:description_term_and_condition'),
        }}
      />
      <Stack alignItems="center">
        <Stack.Item
          alignItems="center"
          css={{
            width: '100%',
            padding: 128,
            background: 'rgba(16, 79, 166, 0.4)',
            backgroundImage: `url("${staticFilePaths.termAndConditionBgWEBP}")`,
            backgroundBlendMode: 'multiply',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            backgroundPositionY: '100%',
          }}
        >
          <Text
            variant="headline2"
            align="center"
            color="white"
            css={{ zIndex: 1 }}
          >
            {data.title}
          </Text>
        </Stack.Item>
        <Stack.Item
          css={{
            ...styles.breakPointsCss,
            margin: 'auto',
          }}
        >
          <ContainerContent
            dangerouslySetInnerHTML={{
              __html: markup,
            }}
          />
        </Stack.Item>
      </Stack>
    </>
  );
}
